var exports = {
  "kL": "x31de4314--cef426--container",
  "cL": "x31de4314--cef426--builder",
  "Dk": "x31de4314--cef426--carousel",
};

module.exports = exports;
